import { lazy } from 'react';

const LibraryTags = lazy(() => import('./tags'));
const LibraryResources = lazy(() => import('./resources'));
const LibraryTenantSelect = lazy(() => import('./tenant-select'));

export { LibraryTags, LibraryResources, LibraryTenantSelect };
